import React from 'react';
import { X } from 'lucide-react';

export function DebugPreviewModal({ debugPreview, onClose }) {
  if (!debugPreview) return null;
  return (
    <div data-testid="debug-preview-overlay" onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 999, background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 440, borderRadius: 20, background: '#FDFBF7', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #E8E3DB', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <p style={{ margin: 0, fontSize: 15, fontWeight: 600, color: '#1A1A18', fontFamily: 'var(--font-sans)' }}>Image Sent to AI</p>
            <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9A9590', fontFamily: 'var(--font-sans)' }}>This is the exact image Nuri AI analyzes</p>
          </div>
          <button onClick={onClose} style={{ width: 32, height: 32, borderRadius: '50%', border: 'none', cursor: 'pointer', background: 'rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <X style={{ width: 16, height: 16, color: '#9A9590' }} />
          </button>
        </div>
        <div style={{ padding: 16 }}>
          <img data-testid="debug-preview-image" src={`data:image/jpeg;base64,${debugPreview.image_b64}`}
            alt="Compressed for AI" style={{ width: '100%', borderRadius: 12, marginBottom: 14, border: '1px solid #E8E3DB' }} />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }}>
            {[
              { label: 'Original', value: `${debugPreview.original_size_kb} KB`, color: '#1A1A18' },
              { label: 'Compressed', value: `${debugPreview.compressed_size_kb} KB`, color: '#5A8C6A' },
              { label: 'Dimensions', value: `${debugPreview.dimensions?.width}x${debugPreview.dimensions?.height}`, color: '#1A1A18' },
              { label: 'Reduction', value: `${debugPreview.reduction_percent}%`, color: '#C67A5C' },
            ].map(item => (
              <div key={item.label} style={{ padding: '10px 14px', borderRadius: 12, background: '#F5F0E8' }}>
                <p style={{ margin: 0, fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, color: '#9A9590', fontFamily: 'var(--font-sans)' }}>{item.label}</p>
                <p style={{ margin: '2px 0 0', fontSize: 14, fontWeight: 600, color: item.color, fontFamily: 'var(--font-sans)' }}>{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
